import axios from 'axios'
import { removeToken } from '../utils/cache'
import { Toast } from 'vant'

const baseUrl = '//marketing.chuanbaoguancha.cn/v1'

let request = axios.create({
	baseURL: baseUrl,
	timeout: 0,
	withCredentials: false,
});

request.interceptors.request.use(function (request) {
	return request;
});

request.interceptors.response.use(function (response) {
	return response.data;
}, function (error) {
	let code = error.response.status;
	if (code === 401) {
		// 权限不足，重新登录
		removeToken();
		Toast({
			message: error.response.data.message || error.response.data.errors,
			type: 'fail',
		})
		return Promise.reject(error.response);
	} else if (code === 404) {
		// 资源不存在
		router.push({ path: '/' })
	} else if (code >= 400 && code < 500) {
		Toast({
			message: error.response.data.message || error.response.data.errors,
			type: 'fail',
		})
		return Promise.reject(error.response);
	} else {
		return Promise.resolve(error.response);
	}
});

export default request;